module.exports = __webpack_public_path__ + "img/no_seal3end.f81e6331.png";